import React from 'react';

import IDynamicFormRow from '../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import OrderLimits from '../components/profile/OrderLimits';

const HomeDeliveryForm: IDynamicFormRow[] = [
  {
    label: 'forms.orders.tableService',
    keyName: 'table_enabled',
    Component: () => <OrderLimits orderType='HOME_DELIVERY' />,
  },
];

export default HomeDeliveryForm;
